import { Button, Space, Typography, Form, Input, Divider, message, Select, Tabs, Tooltip, Alert } from "antd";
import { EditIcon, TrashIcon } from "../../admin/Icons";
import { ColorPicker } from 'react-color-gradient-picker';
import wrap from "../../utils/wrap";
import { canDeleteRecord, makeKey, tt_font_delete, tt_font_reset } from "../../utils/Utils";
import Overlay from "../Overlay";
import { useEffect, useState } from "react";
import UploadFont from "./UploadFont";
import { apiCall } from "../../utils/Api";
import { RedoOutlined } from '@ant-design/icons';
export const getStyle = (_colors = [], _id = 0) => {
    let _f = _colors.find(item => item.id == _id);
    if (_f) {
        return _f.color.style;
    } else {
        return ""
    }
}

export default function Font(props) {

    const [fonts, setFonts] = useState([]);


    const initFonts = [
        {
            "name": "Arial",
            "path": "Arial",
        },
        {
            "name": "Verdana",
            "path": "Verdana",
        },
        {
            "name": "Tahoma",
            "path": "Tahoma",
        },
        {
            "name": "Trebuchet MS",
            "path": "Trebuchet MS",
        },
        {
            "name": "Times New Roman",
            "path": "Times New Roman",
        },
        {
            "name": "Georgia",
            "path": "Georgia",
        },
        {
            "name": "Garamond",
            "path": "Garamond",
        },
        {
            "name": "Courier New",
            "path": "Courier New",
        },

        {
            "name": "Poppins",
            "path": "/fonts/poppins_regular.woff2",
        },

        {
            "name": "Poppins Italic",
            "path": "/fonts/poppins_italic.woff2",
        },

        {
            "name": "Poppins Bold",
            "path": "/fonts/poppins_bold.woff2",
        },

        {
            "name": "Poppins Bold Italic",
            "path": "/fonts/poppins_bold_italic.woff2",
        },

        {
            "name": "Poppins Light",
            "path": "/fonts/poppins_light.woff2",
        },

        {
            "name": "Poppins Light Italic",
            "path": "/fonts/poppins_light_italic.woff2",
        },

        {
            "name": "Poppins Black",
            "path": "/fonts/poppins_black.woff2",
        },

        {
            "name": "Poppins Black Italic",
            "path": "/fonts/poppins_black_italic.woff2",
        },


    ]


    // Pass functions and parameters
    const {
        template = {},
        templates = [],
        remove = () => { },
        reset = () => { },
        save = () => { },
        close = () => { },
        is_new = false,
        is_edit = false,
        data = {}
    } = props;

    // Destructure / Default
    const {
        id = 0,
        name = "",
        path = "",
        is_import = false,
    } = data;

    const can_delete = canDeleteRecord(templates, template, id, "fonts");
    const [regFont, setRegFont] = useState((is_import) ? "" : name);
    const [googleFont, setGoogleFont] = useState({ name: (is_import) ? name : "", path: (is_import) ? path : "" })
    const [includeError, setIncludeError] = useState(false);
    const [isImport, setIsImport] = useState(is_import);

    // Structured object
    const [font, setFont] = useState(
        {
            name: name,
            path: path
        }
    )

    // Save Font
    const saveFont = () => {

        let obj;
        if (isImport) {
            // save google font
            obj = { ...googleFont }
        } else {
            // save regular font
            obj = { ...font }
        }

        obj.id = id;
        obj.is_import = isImport;
        save(obj, is_new, false);
        close();
    }


    const setFontObj = (_obj) => {
        setFont({
            name: _obj.key,
            path: _obj.value
        })
    }

    const dir = '/web_fonts/';
    const fetchList = () => {
        apiCall("files/lsfonts", { location: dir }, (_status, _result) => {
            if (_status) {
                setFonts(_result.files.tree);
            } else {
                message.error(_result.error)
            }
        })
    }

    useEffect(fetchList, []);


    const checkUsed = (array, key, value) => {
        return array.some(obj => obj[key] === value);
    }

    const drawFonts = () => {

        let _f = initFonts.concat([...fonts])

        return _f.map(item => {
            let disabled = checkUsed(props.fonts, "name", item.name)
            return (<Select.Option disabled={disabled} value={item.path} key={item.name} >{item.name}</Select.Option>)
        })
    }

    const stripTag = (_str) => {
        return _str.replace(/<style>|<\/style>|\s*(@import[^;]*;)\s*|\n|\r/g, '$1');
    }

    const validateGoogleFont = (_val) => {
        _val = stripTag(_val);
        setGoogleFont({ ...googleFont, "path": _val });
        const regex = /^@import url\('https:\/\/fonts\.googleapis\.com\/css2\?family=.+&display=swap'\);$/;
        if (!regex.test(_val)) {
            setIncludeError(true)
        } else {
            setIncludeError(false);
        }
    }

    

    const drawUI = () => {

        if (is_import) {
            return (<>
                <div>
                    <label>Font Name:</label>
                    <Input value={googleFont.name} onChange={(e) => setGoogleFont({ ...googleFont, "name": e.target.value })} placeholder="Name..." />
                    <div className="shim" />
                    <label>Google Font Import:</label>
                    {(includeError && <div style={{ "color": "#f00", "marginTop": "-5px" }}><small>Incorrect format.</small></div>)}
                    <Input.TextArea value={googleFont.path} onChange={(e) => validateGoogleFont(e.target.value)} placeholder="@import...." rows={4} />
                </div>
            </>)
        } else {
            return (<>
                <div>
                    <label>Select font:</label>
                    <Select placeholder="Select font..." defaultValue={(path && !is_import) ? path : null} onChange={(e, f) => {
                        setFontObj(f);
                        setRegFont(f.value);
                    }} style={{ "width": "100%" }} >
                        {drawFonts()}
                    </Select>
                </div>
            </>)
        }
    }

    // Draw the edit form
    const drawEdit = () => {
        let _new = (is_new) ? "Activate Uploaded " : "Change ";
        
        return (
            <div key={id} style={{ "padding": "20px" }}>
                <Typography.Title level={5}>{_new} Font</Typography.Title>
                <Divider style={{ "margin": "15px 0px" }} dashed />

                <Alert style={{ "lineHeight": "10px", "marginBottom": "10px" }} description={<div style={{ "lineHeight": "14px" }}><small>The following fonts are either pre-loaded by Bookmanager, or uploaded by you. In order to use them on your webstore, you must selectively choose which ones to activate.</small></div>} />
                {drawUI()}
                <div className="shim" />  <div className="shim" />
                <div className="float-flex">
                    <div>&nbsp;{ }</div>
                    <div><Button disabled={((!regFont && !isImport) || (!googleFont.name && isImport || includeError))} onClick={() => saveFont()} type="primary">Save</Button></div>
                </div>
            </div>
        )
    }


    // Draw the row (Allow clicking on the color to edit)
    const drawRow = () => {
        return (
            <div>
                <div className="float-flex">
                    <Space>
                        <wrap.tags><div className={"bm-font-" + id} ><wrap.elipsis width={200}>{name.replace(".woff2", "").replace(".woff", "")}</wrap.elipsis></div></wrap.tags>
                    </Space>
                    <Space size={0}>
                        {(can_delete && <Tooltip title={tt_font_delete}><Button disabled={(is_import === false && path === "")} onClick={() => remove(id, false)} type="link" icon={<TrashIcon style={{ "color": (is_import === false && path === "") ? "#aaa" : "#f12a46" }} />} size="small" /></Tooltip>)}
                        {(!can_delete && <Tooltip title={tt_font_reset}><Button disabled={(is_import === false && path === "")} onClick={() => reset(id, false)} type="link" icon={<RedoOutlined />} size="small" /></Tooltip>)}
                        <Overlay width="320px" component={<Font fonts={props.fonts} is_edit save={save} data={data} />}>
                            <Button type="link" icon={<EditIcon />} size="small" />
                        </Overlay>
                    </Space>
                </div>
                <div className="shim" />
            </div>
        )
    }

    if (is_new || is_edit) {
        return drawEdit();
    } else {
        return drawRow();
    }

}